import { CognitoUserPool, CookieStorage } from 'amazon-cognito-identity-js'

let USER_POOL: CognitoUserPool | undefined
let STORAGE: CookieStorage | undefined

function buildStorage() {
  return new CookieStorage({
    domain: process.env.NEXT_PUBLIC_COGNITO_COOKIE_STORAGE_DOMAIN,
    path: '/',
    expires: 30,
    sameSite: 'lax',
    secure: true,
  })
}

// CognitoUser instances default to window.localStorage unless this is passed
// to them explicitly, so every CognitoUser construction in Auth.ts must reuse
// this same instance to end up writing the cookies the backend reads.
export function getStorage(): CookieStorage {
  STORAGE ??= buildStorage()
  return STORAGE
}

function buildUserPool() {
  return new CognitoUserPool({
    UserPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID || '',
    ClientId: process.env.NEXT_PUBLIC_COGNITO_WEB_CLIENT_ID || '',
    Storage: getStorage(),
  })
}

export function getUserPool(): CognitoUserPool {
  USER_POOL ??= buildUserPool()
  return USER_POOL
}

const initAuth = () => {
  getUserPool()
}

export default initAuth
